import React from 'react'
import '../../../../../styles/ModalFacturaEmitida.css'
import Printer from '../../../../../media/felsv/Printer.svg'
import Email from '../../../../../media/felsv/Email.svg'
import Download from '../../../../../media/felsv/Download.svg'
import Folder from '../../../../../media/felsv/Folder.svg'
import DownloadImage from '../../../../../media/felsv/DownloadImage.svg'
import DownloadJson from '../../../../../media/felsv/DownloadJson.svg'
import DeleteFileIcon from '../../../../../media/felsv/dark_delete_file_icon.svg'
import {ModalBase} from '../../../../../components/Modals/ModalBase'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {
  actionSujetoExcluidoEmision,
  actionsOperaciones,
} from '../../../../../actions/action-creators'
import {useHistory} from 'react-router-dom'
import {State} from '../../../../../reducers'
import {Tooltip} from '../../../../../components/Tooltip/Tooltip'
import {sujetoExcluidoClearAll} from '../../../../../actions/sujeto-excluido/sujetoExcluidoEmision.actions'
import { generateQRImageFromBits } from '../../../../../actions/operaciones/operaciones.actions'
import { docsDatosReceptorReset } from '../../../../../actions/documentos/documentos.actions'
import { handleRestartStateFormaPago } from '../../../../../actions/forma-pago.actions'

const SEModalResumenFacturaEmitida = () => {
  const history = useHistory()
  const {datosFacturaRes, opcionesActiva, anulado} = useSelector(
    (state: State) => state.sujetoExcluido
  )
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionSujetoExcluidoEmision, dispatch)
  const actionsOP = bindActionCreators(actionsOperaciones, dispatch)

  const nuevaFactura = () => {
    dispatch(sujetoExcluidoClearAll())
    dispatch(docsDatosReceptorReset())
    dispatch(handleRestartStateFormaPago())
    history.push('/otros-documentos/sujeto-excluido/formulario')
  }

  const handlePDF = () => {
    actionsOP.getFacturaPDF_New(
      {Documento: datosFacturaRes?.JsonFactura, Sello: datosFacturaRes?.Sello},
      datosFacturaRes?.serie,
      datosFacturaRes?.estadoanulacion
    )
  }

  const handleExcel = () => {
    actionsOP.getExcelFactura(
      {Documento: datosFacturaRes?.JsonFactura, Sello: datosFacturaRes?.Sello},
      datosFacturaRes?.codigoGeneracion
    )
  }
  const handleImage = () => {
    actionsOP.getFacturaImage(
      {Documento: datosFacturaRes?.JsonFactura, Sello: datosFacturaRes?.Sello},
      datosFacturaRes?.codigoGeneracion
    )
  }
  
  const handleJson = () => actionsOP.descargarJson({idFactura: datosFacturaRes?.codigoGeneracion, json: datosFacturaRes?.JsonFacturaFile})

  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '600px', backgroundColor: '#f1f1f1'}}>
      <div className='modal-card' style={{width: '100%'}}>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>{opcionesActiva ? 'Más Opciones' : 'Factura sujeto excluido emitida!'}</h3>
          </div>
          <div className='form-separator'></div>
          <div className='modal-emitido-div-qr'>
            {datosFacturaRes?.qr && (
              <img src={generateQRImageFromBits(datosFacturaRes?.qr.replace('data:image/jpeg;base64,', '') )} alt='Código-qr' className='modal-emitido-img-qr'/>
            )}
          </div>
          <div
            className='m button-actions'
            style={{margin: '0 auto', width: '100%', textAlign: 'center'}}
          >
            <div style={{display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: "wrap"}}>
              <Tooltip content='Imprimir'>
                <button
                  className='modal-emitido-button-icon'
                  onClick={() => actionsFE.sujetoExcluidoOpenCloseModalImprimir(true)}
                >
                  <img src={Printer} alt='Imprimir' />
                </button>
              </Tooltip>
              <Tooltip content='Enviar por Correo'>
                <button
                  className='modal-emitido-button-icon'
                  onClick={() => actionsFE.sujetoExcluidoOpenCloseModalEmail(true)}
                >
                  <img src={Email} alt='correo electrónico' />
                </button>
              </Tooltip>
              <Tooltip content='Descargar PDF'>
                <button className='modal-emitido-button-icon' onClick={handlePDF}>
                  <img src={Download} alt='Download' />
                </button>
              </Tooltip>
              <Tooltip content='Descargar excel'>
                <button className='modal-emitido-button-icon' onClick={handleExcel}>
                  <img src={Folder} alt='Download folder' />
                </button>
              </Tooltip>
              <Tooltip content='Descargar imagen'>
                <button className='modal-emitido-button-icon' onClick={handleImage}>
                  <img src={DownloadImage} alt='Download 2' />
                </button>
              </Tooltip>
              <Tooltip content='Descargar json'>
                <button className='modal-emitido-button-icon' onClick={handleJson}>
                  <img src={DownloadJson} alt='Download JSON' />
                </button>
              </Tooltip>
              {!anulado && (
                <Tooltip content='Anular'>
                  <button
                    className='modal-emitido-button-icon'
                    onClick={() => actionsFE.sujetoExcluidoOpenCloseModalAnular(true)}
                  >
                    <img src={DeleteFileIcon} alt='Anular factura' />
                  </button>
                </Tooltip>
              )}
            </div>
          </div>
          {!opcionesActiva && (
            <div className='w-layout-hflex button-actions'>
              <button
                className='m button transparent w-inline-block'
                onClick={actionsFE.sujetoExcluidoCloseModalFacturaEmitida}
              >
                Ver detalle completo
              </button>
            </div>
          )}
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button
              className='m button transparent w-inline-block'
              onClick={actionsFE.sujetoExcluidoCloseModalFacturaEmitida}
            >
              <div>Cerrar</div>
            </button>
            {!opcionesActiva && (
              <button className='m button w-inline-block' onClick={nuevaFactura}>
                <div>Nueva factura</div>
              </button>
            )}
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default SEModalResumenFacturaEmitida
